module.exports = __webpack_public_path__ + "img/logoseebbarbacena.9e0ad48b.png";